import { MobileOutlined, LaptopOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import styles from "./layout-footer.module.css";
import { useEffect, useState } from "react";
import useFetch from "../../hooks/useFetch";
import { GetVersionInfo } from "../../utils/api.constant";
import { eResultCode } from "../../utils/enum";

type TVersions = {
  appVersion: string;
  webVersion: string;
};

export default function LayoutFooter() {
  const { post } = useFetch();
  const [versions, setVersions] = useState<TVersions>();
  const getCurrentYear = () => new Date().getFullYear();



 

  return (
    <div className={styles.footer}>
      <div className={styles.footerCondition}>
        <div>
          {versions?.webVersion && (
            <>
              <Tooltip title="Web Version">
                <LaptopOutlined
                  style={{ fontSize: "12px", marginRight: "8px" }}
                />
                <span>v{versions?.webVersion}</span>
              </Tooltip>
              <span style={{ color: "var(--bs-primary)", margin: "0 10px" }}>
                |
              </span>
            </>
          )}

          {versions?.appVersion && (
            <>
              <Tooltip title="Mobile Version">
                <MobileOutlined
                  style={{ fontSize: "12px", marginRight: "8px" }}
                />
                <span>v{versions?.appVersion}</span>
              </Tooltip>
              <span style={{ color: "var(--bs-primary)", margin: "0 10px" }}>
                |
              </span>
            </>
          )}

          <span>Copyright {getCurrentYear()} WebPM</span>
          <span style={{ color: "var(--bs-primary)", margin: "0 10px" }}>
            |
          </span>
          <span>All Rights Reserved</span>
        </div>
      </div>
    </div>
  );
}
